import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categories } from "@/mocks/guagua";

export default function CategorySection() {
  return (
    <section id="categories" className="w-full scroll-mt-20 border-b border-background-200 bg-background-100/70">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          align="center"
          eyebrow="按主题逛"
          title="网爆吃瓜主题分类"
          description="六个常看方向，每个分类下的合集都按更新时间与热度排序，点进去就能顺着读完。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/collections?cat=${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${
                  index % 3 === 0
                    ? "bg-primary-100 text-primary-700"
                    : index % 3 === 1
                      ? "bg-accent-100 text-accent-800"
                      : "bg-secondary-100 text-secondary-800"
                }`}
              >
                <i className={`${cat.icon} text-2xl leading-none`} aria-hidden="true"></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {cat.name}
                  </h3>
                  <span className="shrink-0 text-xs text-foreground-500">{cat.count} 篇</span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}